import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import isEqual from "lodash/isEqual";
import {PlayerReduxState} from "../../../../redux/player/types";
import Content from "./Content";
import Phrase, {PhraseVariant} from "../../../Phrase";
import playInitAgentAction from "../../../../redux/player/actions/playInitAgentAction";

type InitAgentActionContentProps = {
  isHistoryOpen?: boolean;
};

const InitAgentActionContent: React.FC<InitAgentActionContentProps> = ({isHistoryOpen}) => {
  const dispatch = useDispatch();
  const initAgentAction = useSelector((state: PlayerReduxState) => state.initAgentAction, isEqual);

  useEffect(() => {
    if (initAgentAction && !initAgentAction.played) {
      dispatch(playInitAgentAction());
    }
  }, [initAgentAction, dispatch]);

  if (!initAgentAction || initAgentAction.dismissed) return null;
  if (isHistoryOpen) return null;

  return (
    <Content.Container appear>
      <Content variant="avatar">
        <Phrase text={initAgentAction.text ?? ""} variant={PhraseVariant.DEFAULT} />
      </Content>
    </Content.Container>
  );
};

export default InitAgentActionContent;
